import BaseModelAPI from '../BaseModelAPI';

export default class SubcontractRequestDeliveryDetail extends BaseModelAPI {
	static entity = 'subcontractrequestdeliverydetail';
	static entityName = 'subcontractrequestdeliverydetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.subcontractRequestDeliveryId = '';
			this.subcontractRequestDelivery = {};
			this.partId = '';
			this.part = {};
			this.partName = '';
			this.poQtyOutstanding = 0;
			this.stockVendor = 0;
			this.deliveryQty = 0;
			this.uom = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}